<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  name:'',
  watch:{
    "$route":{
      immediate: true,
      handler(e) {
        window.document.title = `${uniteData.name}_${e.name}`;
      }
    }
  },
  methods:{
  },
}
</script>
<style lang="scss">
  @import '@/style/unite.scss';
</style>
